import * as React from 'react';

import Icon from '../../../../icon/Icon.jsx';
import Text from '../../../../text/Text.jsx';

export type SurveyNavButtonProps = {
  iconId: string;
  label?: React.ReactNode;
  hideLabel?: boolean;
} & Omit<
  React.ButtonHTMLAttributes<HTMLButtonElement>,
  'children' | 'type' | 'ref'
>;

const SurveyNavButton = ({ iconId, label, ...props }: SurveyNavButtonProps) => (
  <button className="survey-nav-button" type="button" {...props}>
    <Icon className="survey-nav-button__icon" id={iconId} size="large" />
    {label && (
      <Text className="survey-nav-button__label" variant="copy-label" tag="div">
        {label}
      </Text>
    )}
  </button>
);

export default SurveyNavButton;
